import type { TermsTranslations } from '../en-US/terms.translations';

export const termsTranslations: TermsTranslations = {
  title: 'Términos y Condiciones',
  lastUpdated: 'Última actualización: 7 de marzo de 2025',
  sections: {
    introduction: {
      title: 'Introducción',
      content:
        '¡Bienvenido a BiteCritic! Estos Términos y Condiciones rigen el uso de nuestra plataforma y servicios. Al utilizar BiteCritic, acepta estos términos en su totalidad.',
    },
    userAgreement: {
      title: 'Acuerdo del Usuario',
      content: 'Al crear una cuenta en BiteCritic, acepta:',
      items: [
        'Proporcionar información precisa y veraz',
        'Mantener la seguridad de su cuenta',
        'Asumir la responsabilidad de todas las actividades bajo su cuenta',
        'Cumplir con todas las leyes y regulaciones aplicables',
      ],
    },
    content: {
      title: 'Directrices de Contenido',
      content: 'Al utilizar BiteCritic, acepta:',
      items: [
        'Compartir reseñas auténticas y honestas',
        'Respetar los derechos de propiedad intelectual',
        'No publicar contenido dañino, ofensivo o inapropiado',
        'No participar en spam o comportamiento engañoso',
      ],
    },
    contentRights: {
      title: 'Derechos de Contenido y Retención',
      content: 'Respecto a su contenido en BiteCritic:',
      items: [
        'Usted mantiene la propiedad de su contenido, pero nos otorga una licencia mundial, no exclusiva y libre de regalías para usar, mostrar, distribuir, reproducir, modificar y crear obras derivadas de su contenido en relación con el Servicio y para fines promocionales y de marketing de BiteCritic, incluyendo, pero no limitado a, la visualización en nuestro sitio web, aplicación y plataformas de terceros como redes sociales',
        'Cuando elimine su cuenta, su información personal será anonimizada, pero sus reseñas y otro contenido aportado pueden ser conservados',
        'El contenido aparecerá como publicado por un "Usuario Anónimo" después de la eliminación de la cuenta',
        'Para la eliminación completa de todo el contenido, debe contactarnos directamente en hurricanesoftwaresolutions@gmail.com',
        'Podemos seguir mostrando reseñas anonimizadas para preservar el valor de la plataforma para todos los usuarios',
      ],
    },
    privacy: {
      title: 'Privacidad y Datos',
      content:
        'Nos tomamos su privacidad en serio. Al utilizar BiteCritic, reconoce que:',
      items: [
        'Recopilamos y procesamos sus datos como se describe en nuestra Política de Privacidad',
        'Su perfil público y reseñas son visibles para otros usuarios',
        'Puede controlar su configuración de privacidad a través de su cuenta',
        'Utilizamos cookies y tecnologías similares',
      ],
    },
    community: {
      title: 'Directrices de la Comunidad',
      content: 'Como miembro de la comunidad BiteCritic, acepta:',
      items: [
        'Tratar a otros usuarios con respeto',
        'No acosar ni discriminar a otros',
        'Proporcionar contribuciones constructivas y útiles',
        'Reportar contenido o comportamiento inapropiado',
      ],
    },
    termination: {
      title: 'Terminación de Cuenta',
      content: 'Nos reservamos el derecho a:',
      items: [
        'Suspender o terminar cuentas que violen estos términos',
        'Eliminar contenido que viole nuestras directrices',
        'Modificar o discontinuar servicios con aviso razonable',
        'Anonimizar datos de usuario pero conservar contenido cuando se elimine la cuenta',
        'Procesar solicitudes de eliminación completa enviadas por correo electrónico dentro de 30 días',
      ],
    },
  },
  agreement: {
    checkbox: 'He leído y acepto los Términos y Condiciones',
    required: 'Debe aceptar los Términos y Condiciones para continuar',
    view: 'Ver Términos y Condiciones',
  },
};

export default termsTranslations;
